// 「加入班級說明」複製文字 —— 班級列表與派出作文共用，確保兩處內容一致。
// 對應 kanban 106630：派出作文的複製鈕改為帶出完整說明（同班級列表）。
export const buildClassJoinInstruction = (classCode: string): string =>
  `1. 請同學點擊連結進入翰林AI寫作批改
https://chaiwriting-h.hle.com.tw/

2. 登入教育雲或翰林帳號

3. 點擊【加入班級】

4. 輸入班級邀請碼：${classCode}`;
